import { render, staticRenderFns } from "./h-deposit-request-page.vue?vue&type=template&id=3345e5f0&"
import script from "./h-deposit-request-page.vue?vue&type=script&lang=js&"
export * from "./h-deposit-request-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports